import { gql } from "@apollo/client";

export const EVENT_SUBCONTRACTOR_FIELDS = gql`
    fragment EventSubcontractorFields on ExhibitionEventSubcontractor {
        id
        ee_id
        subcontractor_id
        booked_workers
        getRegisteredWorkers
        relSubcontractor { id title }
    }
`;

export const GET_EVENT_SUBCONTRACTORS = gql`
    query EventSubcontractors($ee_id: ID!) {
        eeSubcontractors(ee_id: $ee_id) {
            ...EventSubcontractorFields
        }
    }
    ${ EVENT_SUBCONTRACTOR_FIELDS }
`;
